import React from 'react';
import {Card, Col, Image, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faCircle, faShare} from "@fortawesome/free-solid-svg-icons";
import CozeSpaceModal from "../../components/CozeSpaceModal";
import ApiService from "../../api/ApiService";
import {toast} from "react-toastify";


export default function CozeSpace() {

    const [spaceAddDlgShow, setSpaceAddDlgShow] = React.useState(false);
    const api = new ApiService();
    const [data, setData] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [hasMoreData, setHasMoreData] = React.useState(true); // 新增状态：是否有更多数据
    const [isFetching, setIsFetching] = React.useState(false); // 新增状态：是否正在获取数据

    // 模拟数据请求函数
    const fetchMoreData = async () => {
        if (!hasMoreData || isFetching) return; // 如果没有更多数据或正在获取数据，直接返回

        setIsFetching(true); // 设置为正在获取数据

        const reponse = await api.getCozeSpaceList();
        const newData = reponse.data;
        // if (newData.length===0){
            setHasMoreData(false);
        // }
        setData(prevData => [...prevData, ...newData]);
        setCurrentPage(prevPage => prevPage + 1);
        setIsFetching(false); // 重置为未获取数据状态

    };

    // 使用 Intersection Observer 监听元素是否进入视口
    const observer = React.useRef();
    const lastElementRef = React.useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isFetching) { // 只有在还有更多数据且未获取数据时才触发加载
                fetchMoreData();
            }
        });
        if (node) observer.current.observe(node);
    }, [hasMoreData, isFetching]);


    function refreshData() {
        setCurrentPage(1);
        setHasMoreData(true);
        setData( [])
        fetchMoreData();
    }

    function setVisible(spaceAddDlgShow) {
        setSpaceAddDlgShow(spaceAddDlgShow)
    }

    async function delCozeSpace(id) {
        var delResult = await api.delCozeSpace(id);
        if (delResult.code === 200) {
            refreshData();
        } else {
            toast.error(delResult.msg)
        }
    }

    return (
        <>
            {/* 内容区域 */}
            <Row>
                {/* 搜索框和按钮 */}
                <Col xs={12} style={{display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: '10px'}}>
                    <button style={{
                        marginLeft: '10px',
                        borderRadius: '50px',
                        background: "transparent",
                        border: '1px solid #02C8E3',
                        color: "#02C8E3",
                        fontSize: '14px',
                        padding: '6px 14px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        怎么复制COZE空间？
                    </button>
                    <button style={{
                        marginLeft: '10px',
                        borderRadius: '50px',
                        background: 'linear-gradient( 155deg, #81F0FF 0%, #02C8E3 100%)',
                        border: 'none',
                        color: "#1E2129",
                        fontSize: '14px',
                        padding: '6px 20px',
                    }} onClick={() => setVisible(true)}>
                        <FontAwesomeIcon icon={faAdd} color={"#060606"} style={{marginRight: '8px'}}/>
                        添加新空间
                    </button>
                </Col>
                {data.length === 0 &&
                    <Col className={'flex-column'} xs={12} style={{
                        backgroundColor: '#1E2129',
                        minHeight: '240px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '10px'
                    }}>
                        <img src="/images/coze/coze_menu_icon_3.svg" alt="暂无数据" width={64} height={64}
                             style={{display: 'block'}}/>
                        <h5 className={'text-center text-white mt-2'}>暂无Coze空间</h5>
                        <p className={'text-center'}
                           style={{color: '#777777'}}>点击“添加新空间”按钮开始添加您的第一个Coze空间</p>
                    </Col>
                }
                {/* 卡片展示区 */}
                <Col xs={12}>
                    <Row>
                        {data.map((card, index) => (
                            <Col key={index} xs={12} md={6} lg={4} xxl={3}
                                 style={{marginTop: '10px', marginBottom: '10px'}}>
                                <Card style={{borderRadius: '8px', background: '#313644'}}>
                                    <Card.Header>
                                        <span className={'badge rounded-pill'} style={{
                                            background: '#242836',
                                            position: 'absolute',
                                            fontSize: '14px',
                                            color: card.joinStatus === 1 ? '#04D7F3' : '#F26363',
                                            top: '5px',
                                            left: '5px',
                                        }}><FontAwesomeIcon icon={faCircle}
                                                            width={'6px'}/> {card.joinStatus === 1 ? '官方已加入' : '等待加入'}</span>
                                        <Image src={card.cover} rounded style={{width: '70px', height: '70px'}}/>
                                    </Card.Header>
                                    <Card.Body style={{marginLeft: '10px', marginRight: '10px', background: '#444A5A'}}>
                                        <h5 className={'text-white'}>{card.title}</h5>
                                        <Card.Text>{card.subTitle}</Card.Text>
                                    </Card.Body>
                                    <Card.Footer className={'d-flex justify-content-between'}>
                                        <a type={'button'} href={`https://www.coze.cn/space/${card.cozeSpaceId}/develop`}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           style={{
                                            textDecoration: 'none',
                                            color: "white",
                                            fontWeight: 'bold',
                                            background: 'linear-gradient(90deg, #02C8E3 10%,#963BC8 150%)',
                                            borderRadius: '4px',
                                            border: 'none',
                                            fontSize: '16px',
                                            padding: '8px 16px'
                                        }}>
                                            <FontAwesomeIcon icon={faShare} width={'18px'}
                                                             style={{marginRight: '6px'}}/>
                                            访问空间
                                        </a>
                                        <button onClick={() => delCozeSpace(card.id)}
                                            style={{
                                            color: "#F25E5E",
                                            fontWeight: 'bold',
                                            background: '#242836',
                                            borderRadius: '4px',
                                            border: 'none',
                                            fontSize: '16px',
                                            padding: '8px 16px'
                                        }}>删除
                                        </button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
                {/* 观察目标元素 */}
                {hasMoreData ? (
                    <div ref={lastElementRef}
                         style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>加载更多...</div>
                ) : (
                    <>
                        {data.length > 0 && 
                            <div style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>没有更多数据了</div>
                        }
                    </>
                )}
            </Row>

            <CozeSpaceModal visible={spaceAddDlgShow} onClose={(refresh) => {
                setVisible(false)
                if (refresh) {
                    refreshData();
                }
            }}/>
        </>
    );
}
